import React from 'react';
import { Badge as AtlasBadge } from '@clearcover/atlas';

interface BadgeProps {
  type: 'ADDED' | 'UPDATED' | 'DELETED';
}

const variantMap: Record<BadgeProps['type'], 'success' | 'warning' | 'danger'> =
  {
    ADDED: 'success',
    UPDATED: 'warning',
    DELETED: 'danger',
  };

const Badge: React.FC<BadgeProps> = ({ type }) => (
  <AtlasBadge variant={variantMap[type]}>{type}</AtlasBadge>
);

export default Badge;
